import { useState } from "react";
import { Box } from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  ptBR,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export default function GridView(props) {
  const [density, setDensity] = useState("compact");
  const theme = createTheme(
    {
      palette: {
        primary: { main: "#ff5722" },
        mode: localStorage.getItem("darkMode") === "true" ? "dark" : "light",
      },
    },
    ptBR,
  );

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        {/*    <GridToolbarExport /> */}
      </GridToolbarContainer>
    );
  };

  return (
    <Box
      sx={{
        padding: 1,
        pt: 0,
        boxSizing: "border-box",
        visibility: "visible",
        //visibility: props.visible ? "visible" : "hidden",
        position: "absolute", //utilizado o position junto com o visibility, pois o display block buga o grid
        height: props.screenHeight - 149,
        width: "calc(100% - 241px)", //tamanho do menu esquerdo
        marginTop: "34px",
      }}
    >
      <ThemeProvider theme={theme}>
        <DataGrid
          sx={{ borderRadius: 0 }}
          rows={props.rows}
          columns={props.columns}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          components={{ Toolbar: CustomToolbar }}
          density={density}
          onDensityChange={(newDensity) => setDensity(newDensity)}
          slots={{
            toolbar: CustomToolbar,
          }}
          /* pagination={false} */
        />
      </ThemeProvider>
    </Box>
  );
}
